import script from "./remote-ssh.vue?vue&type=script&setup=true&lang=ts"
export * from "./remote-ssh.vue?vue&type=script&setup=true&lang=ts"

import "./remote-ssh.vue?vue&type=style&index=0&id=968dae10&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-968dae10"]])

export default __exports__